// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2anDq","newExpiryDate":"styles_newExpiryDate__27QjN","footer":"styles_footer__46pS1"};